// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".coffre-container[data-v-8b10b1f0]{position:relative}.safe[data-v-8b10b1f0]{width:600px;margin:auto}.dialog-frame[data-v-8b10b1f0]{border-radius:0;width:805px;height:350px}.dialog-frame.unlock[data-v-8b10b1f0]{width:100%;height:auto}.dialog-frame label[data-v-8b10b1f0]{margin-top:20px;font-family:Bebas Neue;font-style:normal;font-weight:400;font-size:24px;line-height:22px}", ""]);
// Exports
module.exports = exports;
